export default function () {
	window.onkeydown = function (e) {
		if ([32].indexOf(e.keyCode) > -1 && e.target == document.body) {
			e.preventDefault();
		}
	};
}
